jQuery(document).foundation();

var $= jQuery;
// hamburger mobile
$(document).ready(function(){
  $(".hamburger").click(function(){
    $(this).toggleClass("is-active");
  });
  $(".js-off-canvas-overlay.is-overlay-fixed").click(function(){
    $('.hamburger').removeClass("is-active");
  });
});
// bannerslider home
var homeSwiper = new Swiper('.homebannerslider', {
	effect: 'fade',   
      autoplay: {
         delay: 3000,
         disableOnInteraction: false,
      },
      breakpoints: {
              640: {
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
              },
              768: {
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
              },
              1024: {
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                pagination: {
                  el: '.swiper-pagination',
                  type: 'fraction',
                },
              },
              2000: {
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                pagination: {
                  el: '.swiper-pagination',
                  type: 'fraction',
                },
              },
            }
});
homeSwiper.on('transitionStart', function () {
    var animate = document.getElementById("animatedCircle","animate");
     animate.setAttribute("begin","0s");
     animate.setAttribute("dur","3.2s");
     // animate.setAttribute("repeatcount","indefinite");
    // $('path>.path').append(animate);
   // var outline = document.getElementsByClassName("path")[0];
   // outline.appendChild(animate);
    });
// home project featured slider
var swiper = new Swiper('.homefeaturedprojectSlider', {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      }
});
// home news slider
var swiper = new Swiper('.newsEventsSlider', {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      }
});
// project page banner slider
var swiper = new Swiper('.projectbannerSlider', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
// awards slider - about 
var swiper = new Swiper('.awardsSlider', {
      slidesPerView: 4,
      spaceBetween: 30,
      navigation: {
        nextEl: '.awardNext',
        prevEl: '.awardPrev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      }
    });
// milestone slider
var galleryThumbs = new Swiper('.milestoneYear', {
      spaceBetween: 50,
      slidesPerView: 5, 
      touchRatio: 0,
      loop: true,
      centeredSlides: true,
      // loopedSlides: 5, //looped slides should be the same
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.milestoneNext',
        prevEl: '.milestonePrev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      }
      
    });
    var galleryTop = new Swiper('.milestoneyearDetails', {
      spaceBetween: 10,
      loop:true,
      touchRatio: 0,
      // loopedSlides: 5, //looped slides should be the same
      navigation: {
        nextEl: '.milestoneNext',
        prevEl: '.milestonePrev',
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
// project enquire button name store to hidden field in form
$( document ).ready(function() {
    $( "#projectEnquirenow" ).click(function() {
     var projectName = $(this).attr("data-project");
     $("#projectName").val(projectName);
     $('.wpcf7-form').addClass(projectName);
    });
    
});
// active the tab button in project page
$( document ).ready(function() {
      var pathname = window.location.pathname;
      var termParts = pathname.split("/");
      var last_part = termParts[termParts.length-2];
      localStorage.setItem("currentTab", last_part);
      $('#singleProjectcategory a[data-tab = '+last_part+']').addClass('active');
      $("#singleProjectcategory a").on("click", function(e){
            var currTab = $(this).data("tab");
            localStorage.setItem("currentTab", currTab);
            console.log(currTab);
      });
        var lastSelectedTab = localStorage.getItem("currentTab");
        $('#singleProjectcategory a[data-tab = '+lastSelectedTab+']').addClass('active');
    });
// smooth scroll anchor - project page
$(function() {
        $('.projectnavButtons a').click(function() {
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
              $('html, body').animate({
                scrollTop: target.offset().top - 100 
              }, 1000);
              return false;
          }
        }
    });
});

// carrer page


$( document ).ready(function() {
  $('[data-search]').on('keyup', function() {
    var searchVal = $(this).val();
    var filterItems = $('[data-filter-item]');

    if ( searchVal != '' ) {
      filterItems.addClass('hidden');
      $('[data-filter-item][data-filter-name*="' + searchVal.toLowerCase() + '"]').removeClass('hidden');
    } else {
      filterItems.removeClass('hidden');
    }
  });
  $( "#carrersearchdepartment" ).change(function() {
    var selectedEventType = this.options[this.selectedIndex].value;
    $('.singleJoblIsting').addClass('hidden');
    $('.singleJoblIsting[data-jobcategory="' + selectedEventType + '"]').removeClass('hidden');
  });

// send data to hidden fields
$( "#applyPosition" ).click(function() {
 var jobTitle = $(this).attr("data-jobtitle").toUpperCase();
 var jobPosition = $(this).attr("data-jobposition");
 $("#jobtitle").val(jobTitle);
 $("#jobposition").val(jobPosition);
});
});
